/* -------- idProperties -------- */
export const selectCardType = (s) => s?.govtId?.idProperties?.cardType;

export const selectOrientation = (s) => s?.govtId?.idProperties?.orientation;

export const selectSidesLeft = (s) => s?.govtId?.idProperties?.sidesLeft;

/* -------- common -------- */
export const selectCameraPermissionGuide = (s) => s?.govtId?.common?.cameraPermissionGuide ?? {};

export const selectCameraPermissionGuideUsage = (s) =>
    s?.govtId?.common?.cameraPermissionGuideUsage ?? {};

export const selectImageCroppingMode = (s) => s?.govtId?.common?.imageCroppingMode;
export const selectDocumentAttempts = (s) => s?.govtId?.common?.documentAttempts ?? {};

export const selectDocumentAttemptsCount = (s) => s?.govtId?.common?.documentAttempts?.count;

export const selectGovtIdBrowserSupportTracked = (s) =>
    s?.govtId?.common?.govtIdBrowserSupportTracked ?? null;

export const selectCommonLoading = (s) => s?.govtId?.common?.loading;

/* -------- images -------- */
export const selectImages = (s) => s?.govtId?.images ?? [];

/* -------- processedData -------- */
export const selectIsAcuantProcessingID = (s) => s?.govtId?.processedData?.isAcuantProcessingID;

export const selectTries = (s) => s?.govtId?.processedData?.tries;

export const selectResult = (s) => s?.govtId?.processedData?.result;

export const selectLiveness = (s) => s?.govtId?.processedData?.liveness;

export const selectFaceMatch = (s) => s?.govtId?.processedData?.faceMatch;

export const selectProcessedData = (s) => s?.govtId?.processedData;

export const selectAutoCaptureFailureCount = (s) =>
    s?.govtId?.processedData?.autoCaptureFailureCount ?? 0;

export const selectOcrDocumentType = (s) => s?.govtId?.processedData?.ocrDocumentType;

export const selectSelfieErrorMsg = (s) => s?.govtId?.processedData?.selfieErrorMsg;

/* -------- captureProperties -------- */
export const selectCapturedImageData = (s) => s?.govtId?.captureProperties?.image?.data;

export const selectCapturedImageBase64 = (s) => s?.govtId?.captureProperties?.image?.base64;

export const selectIsSharp = (s) => s?.govtId?.captureProperties?.isSharp;

export const selectIsGlareFree = (s) => s?.govtId?.captureProperties?.isGlareFree;

/* -------- config -------- */
export const selectConfig = (s) => s?.govtId?.config;

export const selectInstanceID = (s) => s?.govtId?.config?.instanceID;

export const selectReplaceFrontID = (s) => s?.govtId?.config?.replaceFrontID;

export const selectReplaceBackID = (s) => s?.govtId?.config?.replaceBackID;

export const selectQualityThreshold = (s) => s?.govtId?.config?.qualityThreshold;

export const selectQualityAttemptCount = (s) => s?.govtId?.config?.qualityAttemptCount;

/* -------- instructions -------- */
export const selectInstructions = (s) => s?.govtId?.instructions ?? {};

export const selectShowInstructions = (s) => s?.govtId?.instructions?.showInstructions;

export const selectInstructionType = (s) => s?.govtId?.instructions?.instructionType;

export const selectLastUsedInstructionType = (s) =>
    s?.govtId?.instructions?.lastUsedInstructionType;

export const selectAutoCaptureEnabled = (s) => s?.govtId?.config?.autoCaptureEnabled ?? true;
